import { useEffect, useState } from 'react'
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    bootstrapSize: 'xs',
    width: undefined,
    height: undefined,
  })

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      if (window.innerWidth < 576) {
        setWindowSize({
          bootstrapSize: 'xs',
          width: window.innerWidth,
          height: window.innerHeight,
        })
      } else if (window.innerWidth < 768) {
        setWindowSize({
          bootstrapSize: 'sm',
          width: window.innerWidth,
          height: window.innerHeight,
        })
      } else if (window.innerWidth < 992) {
        setWindowSize({
          bootstrapSize: 'md',
          width: window.innerWidth,
          height: window.innerHeight,
        })
      } else if (window.innerWidth < 1200) {
        setWindowSize({
          bootstrapSize: 'lg',
          width: window.innerWidth,
          height: window.innerHeight,
        })
      } else {
        setWindowSize({
          bootstrapSize: 'xl',
          width: window.innerWidth,
          height: window.innerHeight,
        })
      }
    }

    // Add event listener
    window.addEventListener('resize', handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, []) // Empty array ensures that effect is only run on mount

  return windowSize
}

export default useWindowSize
